export function HomeSkeleton() {
  return (
    <div className="space-y-6 pb-8">
      <div className="text-center space-y-3 py-4 flex flex-col items-center">
        <div className="w-16 h-16 rounded-full skeleton-shimmer-dark" />
        <div className="h-7 w-64 rounded-lg skeleton-shimmer-dark" />
        <div className="h-4 w-80 max-w-full rounded-lg skeleton-shimmer-dark" />
      </div>

      <div className="h-11 max-w-xl mx-auto rounded-xl skeleton-shimmer-dark" />

      <div className="space-y-3">
        <div className="h-5 w-48 rounded-lg skeleton-shimmer-dark" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
          {Array.from({ length: 10 }).map((_, i) => (
            <div key={i} className="rounded-xl border border-white/15 p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg skeleton-shimmer-dark flex-shrink-0" />
                <div className="flex-1 space-y-2">
                  <div className="h-4 w-2/3 rounded skeleton-shimmer-dark" />
                  <div className="h-3 w-4/5 rounded skeleton-shimmer-dark" />
                </div>
              </div>
              <div className="h-3 w-20 rounded skeleton-shimmer-dark mt-3 ml-[3.25rem]" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
